import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.white,
  fillHoverColor: colors.white,
  iconColor: colors.onyx,
  iconHoverColor: colors.azure,
  iconBorderColor: colors.onyx,
  iconBorderHoverColor: colors.azure
};
export default socialIcon;